// @flow
import * as React from 'react'
import classnames from 'classnames'

import { useFlexStyles } from './styles'
import { isValidHTMLTag } from '~/core/utils/functions'

type FlexProps = {
  as?: string,
  spacing?: 1 | 2 | 3 | 4,
  margin?: 1 | 2 | 3 | 4,
  column?: boolean,
  inline?: boolean,
  justifyStart?: boolean,
  justifyCenter?: boolean,
  justifyEnd?: boolean,
  justifySpaceBetween?: boolean,
  alignCenter?: boolean,
  alignFlexStart?: boolean,
  alignFlexEnd?: boolean,
  stretchItems?: boolean,
  wrap?: boolean,
  className?: string
}

const Flex = React.forwardRef<FlexProps, HTMLElement>(
  (
    {
      as = 'div',
      spacing,
      margin,
      column,
      inline,
      justifyStart,
      justifyCenter,
      justifyEnd,
      justifySpaceBetween,
      alignCenter,
      alignFlexStart,
      alignFlexEnd,
      stretchItems,
      wrap,
      className,
      ...props
    }: FlexProps,
    ref
  ) => {
    const Component = isValidHTMLTag(as) ? as : 'div'
    const classes = useFlexStyles()

    return (
      <Component
        ref={ref}
        className={classnames(
          classes.flexWrapper,
          {
            [`spacing-${spacing || ''}`]: [1, 2, 3, 4].includes(spacing),
            [`margin-${margin || ''}`]: [1, 2, 3, 4].includes(margin),
            column,
            justifyStart,
            justifyCenter,
            justifyEnd,
            justifySpaceBetween,
            alignCenter,
            alignFlexStart,
            alignFlexEnd,
            stretchItems,
            inline,
            wrap
          },
          className
        )}
        {...props}
      />
    )
  }
)

export default Flex
